import {useAppDispatch, useAppSelector, useGetRunningContext} from '../../hooks'
import { selectSession, setGroupId } from '../../app/session'
import SessionParticipants from './SessionParticipants'
import SessionFooter from './SessionFooter'
import BackButton from '../Navigation/BackButton'
import Edit from '../../assets/edit.svg'
import TagDropdown from '../Dropdown/TagDropdown'
import { Session } from 'src/app/types'
import { setType } from 'src/app/modal'

const HostActiveSession = () => {
  const session = useAppSelector(selectSession) as Required<Session>
  const { name, participants, groupId, id } = session
  const dispatch = useAppDispatch()
  const onEditSessionName = () => {
    dispatch(setType({ type: 'sessionRename' }))
  }

  const { runningContext } = useGetRunningContext()

  const onGroupChange = (groupId: string) => {
    dispatch(setGroupId(groupId))
  }

  return (
    <>
      <div className="flex flex-col">
        <BackButton styles="mb-4 self-start" page="Home" />
        <button
          aria-label="edit the session name"
          className="inline-flex items-center self-start mb-4"
          onClick={onEditSessionName}
        >
          <h1 className="font-bold text-base mr-2">{name}</h1>
          <img src={Edit} alt="" />
        </button>
      </div>
      <TagDropdown
        setSelectedOption={onGroupChange}
        selectedValue={groupId}
        popoutWrapperStyles="mb-4"
      />

      {participants && (
        <SessionParticipants isHost = {runningContext==='inMeeting' ? true : false} participants={participants} />
      )}

      <SessionFooter
        participantArr={Object.values(participants)}
        id={id}
        groupId={groupId}
        name={name}
      />
    </>
  )
}

export default HostActiveSession
